import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-accent)";

function IconUnreadComment({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" clip-rule="evenodd" d="M8 2a6 6 0 0 0-6 6v4.5A1.5 1.5 0 0 0 3.5 14H8A6 6 0 0 0 8 2z"/>
            <rect width="6" height="1" rx=".5" transform="matrix(-1 0 0 1 11 6.5)" fill="var(--control-accent-light)"/>
            <rect width="4" height="1" rx=".5" transform="matrix(-1 0 0 1 9 9)" fill="var(--control-accent-light)"/>
        </svg>
    );
}

export default IconUnreadComment;
